import HTMLEditor from "../_commons/Editor/HTMLEditor";

export const MessageEditor = HTMLEditor;